import { CloudProviders } from '@ariksa/cloud-account/api';
import { ComplianceStandards } from '@ariksa/compliance-policies/api';
import { NativeResources } from '@ariksa/inventory-core/api';
import { Clients } from '@ariksa/notification';
import { ApplicationEnum } from 'services/Vulnerability/types';

import { CustomIconTypes, IconType, IconTypes } from 'components/Icons/types';

export const isIconFilled = (type: IconType) => {
  let isFilled = true;
  switch (type) {
    case NativeResources.AzureAdDirectoryRoles:
    case NativeResources.AzureAdsamlRole:
    case NativeResources.AzureAdDomain:
    case CustomIconTypes.Internet:
    case CustomIconTypes.Sagemaker:
    case ComplianceStandards.CisV8:
    case ComplianceStandards.Nist80053:
    case ComplianceStandards.Nist80053Rev5:
    case IconTypes.AmazonLinux:
    case ApplicationEnum.MongoDb:
    case ApplicationEnum.Memcached:
    case ApplicationEnum.ApacheHttp:
    case ApplicationEnum.Cassandra:
    case ApplicationEnum.CouchDb:
    case ApplicationEnum.HaProxy:
    case ApplicationEnum.RabbitMq:
    case IconTypes.Ubuntu:
    case CloudProviders.Gitlab:
    case CloudProviders.Github:
    case CloudProviders.Bitbucket:
    case NativeResources.ElasticSearch:
    case Clients.Elasticsearch:
      //case IconTypes.Debian:
      isFilled = false;
  }
  return isFilled;
};
